// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxListWithLabel from '../../../../shared/components/checkbox-list-with-label';
import DealerHierarchyTerritory from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-territory';
import ToggleCheckboxesButton from '../../../../shared/components/toggle-checkboxes-button';
import {addCollectionLabels} from '../../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../../shared/services/hashmap';

const TerritoryCriteria = props => {

    const dealerSelectionMessage = props.selectedTerritories.length > 0 ? 'DESELECT_ALL' : 'SELECT_ALL';

    return (
        <section className='territory-criteria'>
            <CheckboxListWithLabel
                className='special-allowance-claim-status-dealers'
                initialState={createHashMap(props.selectedTerritories, 'territory')}
                isRequired={true}
                label='TERRITORY'
                list={addCollectionLabels(props.allowedTerritories, 'territory')}
                onChange={props.handleTerritorySelect}
                uid='territory'
            />
            <ToggleCheckboxesButton
                label={dealerSelectionMessage}
                listLength={props.allowedTerritories.length}
                onClick={props.handleSelectAllTerritories}
            />
        </section>
    );

};

TerritoryCriteria.displayName = 'TerritoryCriteria';
TerritoryCriteria.propTypes = {
    allowedTerritories: PropTypes.arrayOf(PropTypes.instanceOf(DealerHierarchyTerritory)).isRequired,
    handleSelectAllTerritories: PropTypes.func.isRequired,
    handleTerritorySelect: PropTypes.func.isRequired,
    selectedTerritories: PropTypes.arrayOf(PropTypes.instanceOf(DealerHierarchyTerritory)).isRequired
};

export default TerritoryCriteria;



// WEBPACK FOOTER //
// ./src/reports/special-allowance-claim-status/components/special-allowance-claim-status-report-criteria/territory-criteria.js